/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Cookies\Cookie.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday June 7th 2023 11:35:16 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Cookies from "universal-cookie";
import Config from "Config/Config";

const cookies = new Cookies();

/**
 * Wrapper class to handle Cookie
 */
class Cookie {
  /**
   * Set the cookie with the new data
   * @param {String} field The identifier of the cookie
   * @param {*} data The data to set
   */
  setCookie(field: string, data: any, dayMultiplyer: number) {
    cookies.set(field, data, {
      path: "/",
      sameSite: "strict",
      domain: Config.BACKEND.PATHS.MY_OWN_URL,
      expires: new Date(Date.now() + dayMultiplyer * 86400000),
    });
  }

  /**
   * Get the cookie from identifier
   * @param {String} field The identifier of the cookie
   * @returns The cookie associated
   */
  getCookie(field: string) {
    return cookies.get(field);
  }

  /**
   * Removes a cookie
   * @param {String} field The identifier
   */
  removeCookie(field: string) {
    cookies.remove(field, { sameSite: "strict" });
  }
}

export default Cookie;
